// const announcementCarouselTrack = document.querySelector(".announcement--carousel-track");
// const announcementCarouselItems = document.querySelectorAll(".announcement--carousel-item");
// const prev_botton = document.querySelector(".announcement-carousel--btn.prev");
// const next_botton = document.querySelector(".announcement-carousel--btn.next");
// const slideHeight = announcementCarouselItems[0].offsetHeight;
// let index = 1,
// allowTransition = true;

// // Clone for infinite loop
// const firstClone = announcementCarouselItems[0].cloneNode(true);
// const lastClone = announcementCarouselItems[announcementCarouselItems.length - 1].cloneNode(true);
// announcementCarouselTrack.appendChild(firstClone);
// announcementCarouselTrack.insertBefore(lastClone, announcementCarouselItems[0]);

// announcementCarouselTrack.style.transform = `translateY(${-slideHeight * index}px)`;

// // Transition logic
// function goToSlide(idx) {
//     if (!allowTransition) return;
//     allowTransition = false;
//     announcementCarouselTrack.style.transition = "transform 0.6s cubic-bezier(0.5,1,0.89,1)";
//     announcementCarouselTrack.style.transform = `translateY(${-slideHeight * idx}px)`;
//     index = idx;
// }

// // Loop logic
// announcementCarouselTrack.addEventListener("transitionend", () => {
//     const allItems = document.querySelectorAll(".announcement--carousel-item");
//     announcementCarouselTrack.style.transition = "none";
//     if (allItems[index].isEqualNode(firstClone)) {
//         index = 1;
//         announcementCarouselTrack.style.transform = `translateY(${-slideHeight * index}px)`;
//     }
//     if (allItems[index].isEqualNode(lastClone)) {
//         index = allItems.length - 2;
//         announcementCarouselTrack.style.transform = `translateY(${-slideHeight * index}px)`;
//     }
//     // Allow new transition after finishing last
//     setTimeout(() => {
//         allowTransition = true;
//     }, 100);
// });

// // Next/Prev Button Logic
// next_botton.onclick = () => goToSlide(index + 1);
// prev_botton.onclick = () => goToSlide(index - 1);

// // Autoplay
// setInterval(() => {
//     goToSlide(index + 1);
// }, 5000);




// const announcementCarouselTrack = document.querySelector(".announcement--carousel-track");
// const announcementCarouselItems = document.querySelectorAll(".announcement--carousel-item");
// const prev_botton = document.querySelector(".announcement-carousel--btn.prev");
// const next_botton = document.querySelector(".announcement-carousel--btn.next");
// const slideHeight = announcementCarouselItems[0].offsetHeight;
// let index = 1,
// allowTransition = true;

// // Clone for infinite loop
// const firstClone = announcementCarouselItems[0].cloneNode(true);
// const lastClone = announcementCarouselItems[announcementCarouselItems.length - 1].cloneNode(true);
// announcementCarouselTrack.appendChild(firstClone);
// announcementCarouselTrack.insertBefore(lastClone, announcementCarouselItems[0]);

// announcementCarouselTrack.style.transform = `translateY(${-slideHeight * index}px)`;

// // Transition logic
// function goToSlide(idx) {
//     if (!allowTransition) return;
//     allowTransition = false;
//     announcementCarouselTrack.style.transition = "transform 0.6s cubic-bezier(0.5,1,0.89,1)";
//     announcementCarouselTrack.style.transform = `translateY(${-slideHeight * idx}px)`;
//     index = idx;
// }

// // Loop logic
// announcementCarouselTrack.addEventListener("transitionend", () => {
//     const allItems = document.querySelectorAll(".announcement--carousel-item");
//     announcementCarouselTrack.style.transition = "none";
//     if (allItems[index].isEqualNode(firstClone)) {
//         index = 1;
//         announcementCarouselTrack.style.transform = `translateY(${-slideHeight * index}px)`;
//     }
//     if (allItems[index].isEqualNode(lastClone)) {
//         index = allItems.length - 2;
//         announcementCarouselTrack.style.transform = `translateY(${-slideHeight * index}px)`;
//     }
//     // Allow new transition after finishing last
//     setTimeout(() => {
//         allowTransition = true;
//     }, 100);
// });

// // Next/Prev Button Logic
// next_botton.onclick = () => goToSlide(index + 1);
// prev_botton.onclick = () => goToSlide(index - 1);

// // Autoplay
// setInterval(() => {
//     goToSlide(index + 1);
// }, 5000);



document.addEventListener("DOMContentLoaded", function () {

  const track = document.querySelector(".announcement--carousel-track");
  if (!track) return;

  const items = document.querySelectorAll(".announcement--carousel-item");
  const prevBtn = document.querySelector(".announcement-carousel--btn.prev");
  const nextBtn = document.querySelector(".announcement-carousel--btn.next");

  let index = 1;
  let allowTransition = true;

  // Direction from setting
  const direction = track.dataset.direction || "vertical";

  // Clone slides
  const firstClone = items[0].cloneNode(true);
  const lastClone = items[items.length - 1].cloneNode(true);

  track.appendChild(firstClone);
  track.insertBefore(lastClone, items[0]);

  // IMPORTANT → Recalculate size AFTER clones added
  let slideSize =
    direction === "horizontal"
      ? track.querySelector(".announcement--carousel-item").offsetWidth
      : track.querySelector(".announcement--carousel-item").offsetHeight;

  // Initial Position
  track.style.transform =
    direction === "horizontal"
      ? `translateX(${-slideSize * index}px)`
      : `translateY(${-slideSize * index}px)`;

  // Slide function
  function goToSlide(i) {
    if (!allowTransition) return;
    allowTransition = false;

    track.style.transition = "transform 0.6s cubic-bezier(0.5,1,0.89,1)";

    track.style.transform =
      direction === "horizontal"
        ? `translateX(${-slideSize * i}px)`
        : `translateY(${-slideSize * i}px)`;

    index = i;
  }

  // Infinite loop logic
  track.addEventListener("transitionend", () => {
    const allItems = document.querySelectorAll(".announcement--carousel-item");
    track.style.transition = "none";

    if (allItems[index].isEqualNode(firstClone)) {
      index = 1;
    }

    if (allItems[index].isEqualNode(lastClone)) {
      index = allItems.length - 2;
    }

    track.style.transform =
      direction === "horizontal"
        ? `translateX(${-slideSize * index}px)`
        : `translateY(${-slideSize * index}px)`;

    setTimeout(() => (allowTransition = true), 50);
  });

  // Buttons
  if (nextBtn) nextBtn.onclick = () => goToSlide(index + 1);
  if (prevBtn) prevBtn.onclick = () => goToSlide(index - 1);

  // Autoplay
  setInterval(() => {
    goToSlide(index + 1);
  }, 5000);

  // Resize event
  window.addEventListener("resize", () => {
    slideSize =
      direction === "horizontal"
        ? track.querySelector(".announcement--carousel-item").offsetWidth
        : track.querySelector(".announcement--carousel-item").offsetHeight;

    track.style.transition = "none";
    track.style.transform =
      direction === "horizontal"
        ? `translateX(${-slideSize * index}px)`
        : `translateY(${-slideSize * index}px)`;
  });

});
